module.exports = __webpack_public_path__ + "static/media/shop-4.e51ec0d0.jpg";